<template>
  <div id="index-work-license">
    <!-- 学生端上岗证界面 -->
    <div class="left">
      <div class="line">
        <div class="li"></div>
        考试中心
      </div>
      <div
        :class="{ line: true, 'active-menu': menu.path == activeMenu }"
        v-for="(menu, index) in menu"
        :key="index"
        @click="gotoChilder(menu)"
      >
        {{ menu.text }}
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import * as base from "../js/base.js";
export default {
  data() {
    return {
      activeMenu: "",
      menu: base.getSubMenuListByFatherMenu("work-license"),
    };
  },
  methods: {
    /**
     * 路由跳转
     */
    gotoChilder(menu) {
      this.activeMenu = menu.path;
      sessionStorage.setItem("subMenu", menu.path);
      this.$router.push("/work-license/" + menu.path);
    },
  },
  mounted() {
    this.activeMenu = sessionStorage.getItem("subMenu");
  },
};
</script>

<style lang="less" scoped>
#index-work-license {
  width: 100%;
  height: 100%;
  display: flex;
  > .left {
    width: 290px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    > .line {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      // justify-content: center;
      padding-left: 80px;
      // font-weight: 600;
      font-size: 15px;
      box-sizing: border-box;
      cursor: pointer;
      &:nth-child(1) {
        padding-left: 25px;
        font-weight: bold;
        font-size: 16px;
        height: 60px;
        cursor: default;
        border-bottom: 1px solid #e7e7e7;
      }
      > .li {
        width: 3px;
        height: 18px;
        background-color: @baseColor;
        margin-right: 8px;
        margin-top: 2px;
      }
    }
    > .active-menu {
      background-color: @baseColor;
      color: #fff;
    }
  }
  > .content {
    width: 0;
    height: 100%;
    flex: 1;
  }
}
</style>